import { isEmpty } from '@jjj/components';
import { createReducer } from '../../../../../../../helpers/reducer';
import actions from './actions';
import { t } from '../../../../../../../i18n';
import { MARKUP_TYPES } from './addBulkMarkupModal';

const getInitialField = (fieldName, value) => ({
  value,
  error: null,
  name: fieldName,
  touched: false,
});

const initState = {
  loading: false,
  isModalVisible: false,
  editForm: {
    markup: getInitialField('markup', MARKUP_TYPES.PERCENT),
    value: getInitialField('value'),
  },
};

function validate(attr, value) {
  let error = '';

  if (attr === 'markup') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.markup_label'),
      });
    }
  }

  if (attr === 'value') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.units.unit.priceList.add_new_pricelist.add_bulk_markup_modal.value_label'),
      });
    }
  }

  return error;
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onClearStore() {
  return {
    ...initState,
    editForm: {
      markup: getInitialField('markup'),
      value: getInitialField('value'),
    },
  };
}

function onShowModal(state) {
  return {
    ...state,
    isModalVisible: true,
  };
}

function onCloseModal(state) {
  return {
    ...state,
    isModalVisible: false,
  };
}

function clearValue(state) {
  const { editForm } = state;

  return {
    ...state,
    editForm: {
      ...editForm,
      value: getInitialField('value'),
    },
  };
}

export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.SHOW_MODAL]: onShowModal,
  [actions.CLOSE_MODAL]: onCloseModal,
  [actions.CLEAR_VALUE]: clearValue,
  [actions.CLEAR_STORE]: onClearStore,
});
